import { Grid } from "@mui/material";
import { ListContextProvider, ShowBase, useListController } from "ra-core";
import { FC } from "react";
import { Content } from "~/components/content/Content";
import DatabaseUpdatesTable from "~/components/governance/DatabaseUpdatesTable";
import { DataCatalogTile, DataClassificationTile, DataOwnershipTile, PlaceholderTile } from "~/components/governance/entryTiles";
import { OdResourcePageProps } from "~/types/resource";
import SecurityIcon from '@mui/icons-material/Security';



const GovernanceDashboard: FC<OdResourcePageProps> = () => {

  const listCtrl = useListController({ resource: 'govrnc-dashboard', basePath: '', sort: { field: 'name', order: 'ASC'} })

  return (
    <ShowBase resource="governance/dashboard" basePath="" id="-1" >
      <Content pageName="Data Catalog" resourceName="Data Catalog">
        <Grid 
          container
          spacing={4}
          sx={{ pt: 2 }}
        >
          <Grid item xs={12} sm={6} md={3}>
            <DataCatalogTile />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataClassificationTile />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataOwnershipTile />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <PlaceholderTile name="Data Audit" icon={<SecurityIcon />} />
          </Grid>
          <Grid item xs={12}>
            <ListContextProvider value={listCtrl}>
              <DatabaseUpdatesTable />
            </ListContextProvider>
          </Grid>
        </Grid>
      </Content>
    </ShowBase>
  )
}

export default GovernanceDashboard;
